import * as am4core from "@amcharts/amcharts4/core";

export const setCountryData = (data) => {
    let tempData = [];
    if (data) {
        Object.keys(data).forEach((key) => {
            if (key !== 'ALL_INTERNATIONAL') {
                tempData.push({
                    id: key.split("_")[0],
                    name: key.split("_")[1],
                    //noOfcases: (data[key].completedCases + data[key].incompleteCases),
                    businessRelations: data[key].businessRelations,
                    score: data[key].avgScore,
                    riskLevelMap: data[key].riskLevelMap
                });
            }
        })
    }
    return setCountryColour(tempData)
}

export const setCountryColour = (countryList) => {
    let highRiskWeight = 3, mediumRiskWeight = 2, lowRiskWeight = 1;
    // color: am4core.color("#367B25")
    let tempCountry = copyArray(countryList)
    tempCountry.forEach(country => {
        let weightedAverage = Math.round(((country.riskLevelMap.LOW * lowRiskWeight) + (country.riskLevelMap.MEDIUM * mediumRiskWeight) + (country.riskLevelMap.HIGH * highRiskWeight)) / (country.riskLevelMap.HIGH + country.riskLevelMap.LOW + country.riskLevelMap.MEDIUM));
        if (weightedAverage === 1) {
            country.fill = am4core.color("#88e81f")
        } else if (weightedAverage === 2) {
            country.fill = am4core.color("#f9d363")
        } else {
            country.fill = am4core.color("#FF6262")
        }
    });
    return tempCountry
}

export const setStateData =(data, statesList, corporateId)=>{
    statesList = statesList.map(i=>i.id + '_' + i.properties.name.replaceAll(' ','_'));
    let tempData = [];
    Object.entries(data).forEach(state=>state[0] && tempData.push({id:state[0].split("_")[0], name: state[0].split('_').slice(1).join(' '), ...state[1]}))
    return setStateColour(tempData);
}

export const setStateColour = (stateList) => {
    let tempState = copyArray(stateList);
    tempState.forEach(state => {
        if (state.avgScore  >= 70) {
            state.fill = am4core.color("#88e81f");
        } else if (state.avgScore  >= 50 ) {
            state.fill = am4core.color("#f9d363");
        } else {
            state.fill = am4core.color("#FF6262");
        }
    });
    return tempState
}

export const copyArray = (data) => {
    let tempLevelOne = JSON.stringify(data);
    return JSON.parse(tempLevelOne)
}

export const getLegendSlicedData = (countryListData) => {
    let tempLegendData = copyArray(countryListData);
    return tempLegendData.slice(0, 5)
}

